import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { BiMath } from "../libs/BiMath";
import { App } from "../App";
import { ERC20Contract } from "../contracts/ERC20Contract";

export class CmpInputAddress extends com.CmpInputAddressBase {

    private _onChangeValue:gs.EventGS<string>;
    private _onChangeValueToken:gs.EventGSToken<string>;
    private _address:string;

    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken<string>();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);
        let cacheValue = "";
        const onInput = 
            async ()=>{
                let value = this._clearValueFunc(this.ctrls.iValue.value);
                if (value===false) {this.ctrls.iValue.value = cacheValue; return;}
                cacheValue = value;
                if (BiMath.isValidAddress(cacheValue))
                {
                    this._onChangeValueToken.invoke(cacheValue);
                    const erc20 = new ERC20Contract(cacheValue,App.chain.provider);
                    this.ctrls.blockInfo.hide();
                    this._address='';
                    const symbol = await erc20.symbol();
                    this.setToken(symbol, cacheValue);
                } else
                {
                    this._address='';
                    this.ctrls.blockInfo.hide();
                }
            }
        this.ctrls.iValue.el.addEventListener('input', onInput);
        if (!this.ctrls.iValue.value) onInput();
        this.ctrls.iValue.value=this.ctrls.iValue.value;
    }

    public get onChangeValue() {return this._onChangeValue;}

    public getAddress() {return this._address;}

    public reset() {
        this._address='';
        this.ctrls.iValue.value='';
        this.ctrls.blockInfo.hide();
    }

    public setToken(symbol:string, address:string)
    {
        this._address = address;
        if (!symbol) {symbol = "ERC20?"; this.ctrls.imgIcon.hide();} 
        else { this.ctrls.imgIcon.show(); }
        this.ctrls.lAddressName.text = symbol;
        this.ctrls.imgIcon.src="files/images/erc20/"+address.toLowerCase()+".webp";
        if (this.ctrls.iValue.value!=address) this.ctrls.iValue.value=address;
        
        this.ctrls.blockInfo.show();
    }

    private _clearValueFunc(value:string){         
        if (value=="") return value;
        if (!value.startsWith("0x")) value = "0x" + value;
        const regex = /^0x[0-9A-Fa-f]+$/;
        if (!regex.test(value)) return false;
        return value;
    }
}